<template>
  <b-card class="p-1">
    <form-component :page="isnpirationSite" @onSubmit="onSubmit" @fetchByLocale="fetchInspirationsSite" />
  </b-card>
</template>

<script>
import FormComponent from '@/components/inspirations/pages/FormComponent.vue';
import NotificationMixin from '@/mixins/NotificationMixin';
import { getSite, updateSite } from '@/http/inspirations';
import { createInspirationsSiteForm } from '@/constants/utils/form';

export default {
  mixins: [NotificationMixin],
  components: {
    FormComponent,
  },

  data() {
    return {
      isnpirationSite: {
        lang: '',
        title: '',
        value: '',
        title_image: null,
      },
    };
  },

  methods: {
    fetchInspirationsSite(lang = 'pl') {
      getSite(lang)
        .then(async ({ data: { data } }) => {
          if (!data) return;

          this.isnpirationSite = data;
        })
        .catch(() => {
          this.showErrorNotification(
            'Problem z pobraniem danych',
            'Wystąpił błąd podczas pobierania danych. Skontaktuj się ze swoim developerem.',
          );
        });
    },
    onSubmit(data) {
      const form = createInspirationsSiteForm(data);

      updateSite(form)
        .then(() => {
          this.showSuccessNotification('Dane zapisane', 'Strona została zapisana.');
        })
        .catch(() => {
          this.showErrorNotification(
            'Problem z zapisaniem danych',
            'Wystąpił błąd podczas zapisywania danych. Skontaktuj się ze swoim developerem.',
          );
        });
    },
  },
};
</script>
